<template>
  <div :class="{ 'header-wrapper': 1, headerSticky: headerSticky }" :style="{
      background: $store.state.theme.theme
        ? $store.state.theme.theme
        : 'rgb(23, 120, 255)',
    }">
    <el-row type="flex" class="row-bg" justify="space-between">
      <el-col :span="4">
        <div>
          <div :class="{
              'header-logo': 1,
              'no-pointer': $route.fullPath.indexOf('/commonExam/') != -1,
            }">
            <!-- {{ $route.fullPath.indexOf('/commonExam/') }} -->
            <el-image v-if="
                $route.fullPath.indexOf('/commonExam/') === -1 &&
                  $route.fullPath.indexOf('/matchDetail/') === -1
              " @click="GotoClassRoom" class="header-logo-img" src="https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/homepage/classroom.png"></el-image>
            <el-image class="header-logo-img" src="https://wugecdn.steam.fun/resources/static/homepage/saikaozhongxin.png"></el-image>
          </div>
        </div>
      </el-col>
      <el-col :span="14">
        <div class="header-title">
          <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" text-color="#ffffff" active-text-color="#fcdb95" menu-trigger="hover">
            <!-- <el-menu-item index="2" @click="$router.push({ name: 'community-home' })">题库中心</el-menu-item> -->
            <el-submenu index="1" popper-class="wg-submenu" active-text-color="#fff">
              <!-- @click="$router.push({ name: 'CompetitionCenter-QuestionBankCenter' })" -->
              <template slot="title">
                <span :style="cssVars">题库中心</span>
                <i class="el-submenu__icon-arrow el-icon-caret-bottom"></i>
              </template>
              <el-menu-item index="1-1" @click="
                  $router.push({
                    name: 'CompetitionCenter-QuestionBankCenter-Platform',
                  })
                " :style="cssVars">平台题库</el-menu-item>
              <el-menu-item index="1-2" @click="
                  $router.push({
                    name: 'CompetitionCenter-QuestionBankCenter-Campus',
                  })
                " :style="cssVars">校区题库</el-menu-item>
            </el-submenu>
            <!-- <el-menu-item
              index="2"
              @click="
                $router.push({ name: 'CompetitionCenter-TestPaperCenter' })
              "
              >试卷中心</el-menu-item
            > -->
            <el-menu-item index="3" @click="
                $router.push({ name: 'CompetitionCenter-PracticeAndExams' })
              ">练习/考试</el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="header-state">
          <div>
            <el-row v-if="$store.getters.username">
              <el-col :span="18" style="white-space: nowrap;text-overflow: ellipsis;">
                <div style="text-align: right">
                  <span v-if="
                      schoolanagement_show &&
                        (classroom_show || classroomstu_show)
                    " @click="GotoSchool">
                    <el-badge style="margin-right:10px">
                      <!-- <i style="margin-right: 0px;font-size: 18px; border-radius: 15px; color: #666666;cursor: pointer; padding:4px;background-color:white; "
                          class="el-icon-school"></i> -->
                      <div style="width: 24px;height: 24px;background-color: #fff;border-radius: 50%;padding-top: 3px;cursor: pointer;box-sizing: border-box;margin-top: -3px;">
                        <div style="width: 18px;height: 18px;margin-left: 3px;">
                          <div style="float: left;">
                            <svg t="1712728449571" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5083" width="18" height="18">
                              <path d="M949.333333 424.533333h-874.666666c-12.8 0-23.466667-8.533333-29.866667-19.2-4.266667-12.8-2.133333-25.6 6.4-36.266666l149.333333-166.4c12.8-12.8 32-14.933333 44.8-2.133334 12.8 12.8 12.8 34.133333 2.133334 46.933334L149.333333 356.266667h802.133334c17.066667 0 32 14.933333 32 34.133333-2.133333 19.2-17.066667 34.133333-34.133334 34.133333zM74.666667 599.466667h874.666666c12.8 0 23.466667 8.533333 29.866667 19.2 4.266667 12.8 2.133333 25.6-6.4 36.266666l-149.333333 166.4c-12.8 12.8-32 14.933333-44.8 2.133334-12.8-12.8-12.8-34.133333-2.133334-46.933334l98.133334-108.8H74.666667c-17.066667 0-32-14.933333-32-34.133333 0-19.2 14.933333-34.133333 32-34.133333z" fill="#3876F6" p-id="5084"></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </el-badge>
                  </span>
                  <span @click="GotoSchool" style="color:#fff;margin-right:20px;font-size: 12px;cursor: pointer;" v-if="
                      schoolanagement_show &&
                        (classroom_show || classroomstu_show)
                    ">校区管理</span>

                  <span v-if="$store.state.user.schoolInfo.adminNoticeAuth">
                    <span v-if="$store.state.user.userInfo.noticeAuth">
                      <el-badge :value="notice_nolook > 0 ? notice_nolook : null" style="margin-right: 20px">
                        <i style="
                                                  margin-right: 0px;
                                                  font-size: 24px;
                                                  color: white;
                                                  cursor: pointer;
                                                " class="el-icon-message-solid" @click="LookNotices"></i>
                      </el-badge>
                      <span style="vertical-align:middle;margin-right:15px;">
                        <el-tooltip class="item" effect="dark" content="帮助中心" placement="bottom">
                          <a href="https://help.steam.fun" target="_blank">
                            <img src="@/assets/image/help.png" alt="" style="width:18px;border-radius:50%;">
                          </a>
                        </el-tooltip>
                      </span>
                    </span>
                  </span>
                  <span style="line-height: 60px; color: white; font-size: 16px" @click="drawer = true">欢迎 ,
                  </span>
                  <span style="line-height: 60px;color: white; font-size: 16px;font-weight: bold;" v-if="$store.state.user.identity === 2" class="username">
                    {{ $store.state.user.userInfo.stuUserInfo.realName }}</span>
                  <el-tooltip v-else class="item" effect="dark" :content="$store.state.user.userInfo.realName" placement="bottom">
                    <span style="max-width:64px;line-height: 60px;color: white;font-size: 16px;font-weight: bold; display: inline-block;white-space: nowrap;overflow: hidden;vertical-align: top;text-overflow: ellipsis;" class="username">
                      <!-- {{ $store.state.user.userInfo.realName.slice(0, 4) }} -->
                      {{ $store.state.user.userInfo.realName }}
                    </span>
                  </el-tooltip>
                </div>
              </el-col>
              <el-col :span="6">
                <div style="text-align: center">
                  <el-dropdown>
                    <el-avatar style="margin-top: 12px; border: 1px solid white" size="medium" :src="
                        $store.state.user.userInfo.userImageUrl
                          ? $store.state.user.userInfo.userImageUrl
                          : $store.state.user.userInfo.headimgUrl
                      "></el-avatar>

                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="classroom_show">
                        <router-link :to="{ name: 'classroomIndex' }" tag="li">我的教室</router-link>
                      </el-dropdown-item>
                      <el-dropdown-item v-if="classroomstu_show">
                        <router-link :to="{ name: 'code-classroom-stu' }" tag="li">我的教室</router-link>
                      </el-dropdown-item>

                      <el-dropdown-item v-if="community_show">
                        <router-link :to="{ name: 'community-home' }" tag="li">作品社区</router-link>
                      </el-dropdown-item>

                      <el-dropdown-item v-if="schoolanagement_show">
                        <span @click="GotoSchool" tag="li">校区管理</span>
                      </el-dropdown-item>

                      <el-dropdown-item divided>
                        <userinfo></userinfo>
                      </el-dropdown-item>

                      <el-dropdown-item>
                        <passward></passward>
                      </el-dropdown-item>

                      <el-dropdown-item divided @click.native="layout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-drawer title="系统消息" :visible.sync="drawer" :direction="direction" size="50%" append-to-body>
      <div class="notice_css">
        <el-timeline style="margin: 10px">
          <el-timeline-item v-for="item in noticeUserList" :key="item.id" :timestamp="item.noticeInfo.created_time" placement="top">
            <el-card style="margin: 10px">
              <div slot="header" class="clearfix">
                <span>{{ item.noticeInfo.title }}</span>
                <el-button v-if="item.is_read" style="float: right; padding: 3px 0; color: grey" type="text" disabled>已读
                </el-button>

                <el-button v-else style="float: right; padding: 3px 0" type="text" @click="SignNoticeState(item)">标为已读
                </el-button>
              </div>

              <p v-html="item.noticeInfo.content"></p>
            </el-card>
          </el-timeline-item>
        </el-timeline>

        <div style="margin: 20px; text-align: center">
          <el-pagination @current-change="handleCurrentChange" :current-page="page_no" :page-size="page_size" layout="total,prev, pager, next" :total="total"></el-pagination>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getUserCampusList,
  getTchNoticeList,
  updateNoticeIsReatState,
  getTchRecentNotReadNotice,
} from '@/api/educational.js'
import userinfo from '@/components/userinfo'
import passward from '@/components/passward'
export default {
  name: 'CompetitionCenter-header',
  props: {
    bgcolor: String,
  },
  data() {
    return {
      is_principal: false, //超级管理员
      header_show: false,
      home_show: false,
      classroom_show: false, //我的教室
      classroomstu_show: false, //学生我的教室
      preparelesson_show: false, //备课中心
      community_show: false, //编程社区
      schoolanagement_show: false, //学校管理
      props: { multiple: true },
      school_list: [], //校区列表
      Select_School: [], //所选校区
      show_school: false,
      school_logo: '',
      bgColor: this.$store.state.theme.theme,

      has_notice: false, //老师账号显示通知
      notice_nolook: 0,
      dialogVisible1: false, //通知显示框
      notice_form: {
        noticeUserId: '',
        title: '',
        content: '',
      },
      drawer: false,
      direction: 'ltr',
      noticeUserList: [], //通知列表
      page_no: 1,
      page_size: 20,
      total: 0,
    }
  },

  components: { userinfo, passward },
  mounted() {
    const roleList = this.$store.getters.roleList
    const is_principal = this.$store.getters.is_principal

    if (is_principal) {
      this.header_show = true
      this.home_show = true
      this.classroom_show = true
      this.preparelesson_show = true //备课中心
      this.community_show = true //编程社区
      this.schoolanagement_show = true //学校管理

      for (let i = 0; i < roleList.length; i++) {
        if (roleList[i] === 2) {
          //教师
          this.classroom_show = true
        }
      }
    } else {
      if (roleList) {
        for (let i = 0; i < roleList.length; i++) {
          if (roleList[i] === 5) {
            //管理员
            this.header_show = true
            this.home_show = true
            this.community_show = true
            this.schoolanagement_show = true
          } else if (roleList[i] === 1) {
            //校长
            this.header_show = true
            this.home_show = true
            this.community_show = true
            this.schoolanagement_show = true
          } else if (roleList[i] === 2) {
            //教师
            this.header_show = true
            this.home_show = true
            this.classroom_show = true
            this.preparelesson_show = true
            this.community_show = true
            this.schoolanagement_show = true
          } else if (roleList[i] === 3) {
            //教务
            this.header_show = true
            this.home_show = true
            this.community_show = true
            this.schoolanagement_show = true
            console.log('教务')
          } else if (roleList[i] === 4) {
            //销售
            this.header_show = true
            this.home_show = true
            this.community_show = true
            this.schoolanagement_show = true
            console.log('销售')
          } else if (roleList[i] === '财务') {
            this.header_show = true
            this.home_show = true
            console.log('财务')
            this.schoolanagement_show = true
          } else if (roleList[i] === 6) {
            //前台
            this.header_show = true
            this.home_show = true
            this.community_show = true
            this.schoolanagement_show = true
            console.log('前台')
          }
        }
      } else {
        this.header_show = true
        this.home_show = true
        console.log('学生')
        this.classroomstu_show = true
        this.community_show = true
      }
    }

    if (this.$store.state.user.token) {
      console.log('用户已登陆')
      this.getUserCampusList()

      //检测是否有通知
      if (this.$store.state.user.identity == '1') {
        this.has_notice = true
        this.notice_nolook = sessionStorage.getItem('notReadNum')
        this.getTchRecentNotReadNotice()
      }
    }
  },

  activated() {
    console.log('当前路径')
    console.log(this.$route.path)
  },

  computed: {
    activeIndex: function () {
      if (
        this.$route.path == '/competitionCenter/questionBankCenter/platform'
      ) {
        return '1-1'
      } else if (
        this.$route.path == '/competitionCenter/questionBankCenter/campus'
      ) {
        return '1-2'
      } else if (this.$route.path == '/competitionCenter/testPaperCenter') {
        return '2'
      } else if (this.$route.path == '/competitionCenter/practiceAndExams') {
        return '3'
      } else {
        return '1'
      }
    },
    headerSticky() {
      switch (this.$route.path) {
        case '/competitionCenter/questionBankCenter/campus':
        case '/competitionCenter/testPaperCenter':
        case '/competitionCenter/practiceAndExams':
          return true
        default:
          return false
      }
    },
    cssVars() {
      return {
        '--color': this.$store.state.theme.theme,
      }
    },
  },

  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },

    chooseTools(cmd) {
      console.log(cmd)
      if (cmd == 'jrcode') {
        window.open('/jrcode/index.html')
      } else if (cmd == 'scratch') {
        window.open('/scratch/index.html')
      } else if (cmd == 'python') {
        window.open('/python/index.html')
      }
    },
    //退出登陆
    layout() {
      this.$store.dispatch('LogOut').then(() => {
        sessionStorage.setItem('schoolInfo', null)

        this.$message.success('退出成功')
        this.$router.push({ path: '/' })
        location.reload()
      })
    },

    //返回教室
    GotoClassRoom() {
      if (this.$store.state.user.identity == '2') {
        this.$router.push({ name: 'classroomIndexStu' })
      } else {
        this.$router.push({ name: 'classroomIndex' })
      }
    },
    GotoSchool() {
      console.log('当前客户权限表-头像')
      console.log(this.$store.getters.permisionList)

      let name = ''
      if (this.$store.getters.permisionList.length > 0) {
        if (this.$store.getters.permisionList[0].children.length > 0) {
          name = this.$store.getters.permisionList[0].children[0].alias.split(
            ','
          )[0]
        } else {
          name = this.$store.getters.permisionList[1].children[0].alias.split(
            ','
          )[0]
        }
      }

      this.$router.push({
        name: name,
      })
    },

    getTchRecentNotReadNotice() {
      getTchRecentNotReadNotice({}).then((res) => {
        console.log('通知列表')
        console.log(res, 12454878)
        // this.total = res.total;
        sessionStorage.setItem('notReadNum', res.notReadNum)
        this.notice_nolook = sessionStorage.getItem('notReadNum')
        console.log(res.notReadNum, 123645678)
        let noticeUserList1 = []
        // this.noticeUserList = res.noticeUserList;
        if (res.notReadNotice) {
          noticeUserList1.push(res.notReadNotice)
          console.log(noticeUserList1, 12454878)
          if (noticeUserList1.length > 0) {
            if (!noticeUserList1[0].is_read) {
              console.log('首条消息未读')
              this.notice_form.noticeUserId = noticeUserList1[0].id

              if (noticeUserList1[0].noticeInfo.notice_type == '1') {
                console.log('弹出-仅标题')

                var notice_html = noticeUserList1[0].noticeInfo.content.replace(
                  /<\/?.+?>/g,
                  ''
                )
                var notice = notice_html.replace(/ /g, '') //dds为得到后的内容

                this.$alert(notice, noticeUserList1[0].noticeInfo.title, {
                  confirmButtonText: '知道了',
                  callback: (action) => {
                    console.log('action')
                    console.log(action)
                    if (action == 'confirm') {
                      console.log('已读')
                      this.updateNoticeIsReatState()
                    }
                  },
                })
              } else if (noticeUserList1[0].noticeInfo.notice_type == '2') {
                console.log('弹出-标题及内容')
                this.dialogVisible1 = true
                this.notice_form.title = noticeUserList1[0].noticeInfo.title
                this.notice_form.content = noticeUserList1[0].noticeInfo.content
              }
            }
          }
        }
      })
    },

    //已读消息
    updateNoticeIsReatState() {
      updateNoticeIsReatState({
        noticeUserId: this.notice_form.noticeUserId,
      }).then((res) => {
        console.log('消息标为已读')
        console.log(res)
        if (res.is_update) {
          this.getTchNoticeList()
          this.getTchRecentNotReadNotice()
          this.dialogVisible1 = false
        }
      })
    },

    //标记未读信息
    SignNoticeState(item) {
      this.notice_form.noticeUserId = item.id
      this.updateNoticeIsReatState()
    },
    getTchNoticeList() {
      getTchNoticeList({
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.total = res.total
        // this.notice_nolook = res.notReadNum;
        this.noticeUserList = res.noticeUserList
        console.log('查看消息列表')
      })
    },

    //系统消息分页
    handleCurrentChange(val) {
      this.page_no = val
      this.getTchNoticeList()
    },

    //查看消息列表
    LookNotices() {
      getTchNoticeList({
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.total = res.total
        // this.notice_nolook = res.notReadNum;
        this.noticeUserList = res.noticeUserList
        console.log('查看消息列表')
        this.drawer = true
      })
    },
    //所得账号所负责的校区
    getUserCampusList() {
      getUserCampusList().then((res) => {
        console.log('获得分校列表')
        console.log(res)
        this.school_list = res.userDeptList
        for (let k = 0; k < res.userDeptList.length; k++) {
          this.Select_School.push(res.userDeptList[k].dept_id)
        }
        this.$store.commit('SET_SELECTSCHOOL', this.Select_School)
      })
    },
  },
}
</script>

<style lang="scss">
.notice_css {
  overflow-y: scroll;
  height: calc(100vh - 40px);
}
.header-title {
  .el-menu {
    display: flex;
    align-items: center;
    height: 60px;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: 0;
    background-color: transparent;

    .el-submenu {
      &:hover,
      &.is-active {
        // background-color: rgb(23, 120, 255);
        // color: #fff !important;
        .el-submenu__title {
          opacity: 1;
        }
        &.is-active {
          .el-submenu__title {
            font-weight: 600;
          }
        }
      }
      .el-submenu__title {
        height: 32px;
        line-height: 32px;
        font-size: 16px;
        font-weight: 400;
        opacity: 0.85;
        color: #fff !important;
        border: none !important;
        transition: opacity 0.2s;

        span {
          vertical-align: initial;
        }

        i {
          color: #fff;

          &.el-submenu__icon-arrow {
            margin: 0 0 0 3px !important;
            font-size: 14px;

            &.el-icon-arrow-down {
              display: none;
            }
          }
        }
      }
    }

    .el-menu-item {
      height: 32px;
      line-height: 32px;
      transition: opacity 0.2s;
      font-weight: 400;
      opacity: 0.85;
      &:hover,
      &.is-active {
        background-color: var(--color) !important;
        color: #fff !important;
        opacity: 1;
        &.is-active {
          font-weight: 600;
        }
      }
    }
  }
}

.header-title .el-menu--horizontal > .el-menu-item.is-active {
  border: 0;
}

.header-title .el-menu--horizontal > .el-menu-item {
  border: 0;
}

.header-title .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.header-title .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.header-title .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  /* background-color: rgba(75, 75, 75, 0.466); */
  background-color: transparent;
  // opacity: 0.85;
}

.wg-submenu {
  .el-menu {
    min-width: auto;
    padding: 10px 8px;
    border-radius: 8px;

    .el-menu-item {
      border-radius: 8px;
      transition: all 0.2s;
      color: #666 !important;
      &:first-child {
        margin-bottom: 3px;
      }
      &:hover,
      &.is-active {
        background-color: var(--color) !important;
        color: #fff !important;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.tools {
  text-align: center;
}

.header-wrapper {
  position: relative;
  width: 100%;
  height: 60px;
  // top: 0px;
  color: white;
  z-index: 10;
  &.headerSticky {
    position: sticky;
    top: 0;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .header-logo {
    width: 155px;
    height: 60px;
    overflow: hidden;

    margin-top: 5px;
    margin-left: 20px;
    cursor: pointer;
    &.no-pointer {
      cursor: initial;
    }
    .header-logo-img {
      width: 100%;
    }
  }

  .header-title {
    // text-align:  center;
    font-weight: bold;
  }

  .header-state {
    text-align: center;
    height: 60px;
  }
  /deep/ .el-avatar img {
    width: 100%;
  }
}
</style>
